export default __webpack_public_path__ + "static/media/favicon.271219da.png";